import { ConnectionService } from '@app/shared/services/connection.service';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageHeaderComponentModel } from '@app/shared/interfaces/page-header-component-model';
import { environment } from 'src/environments/environment';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { CommonService } from '@product/shared/services/common.service';
import { BaseComponent } from '../base-component/base-component.component';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.less'],
})
export class PageHeaderComponent extends BaseComponent implements OnInit {
  @Input() componentModel: PageHeaderComponentModel;
  @Input() submitButtonDisabled = false;
  @Input() showCancel = true;
  @Input() showHistory = false;
  @Input() showLanguage = false;
  @Input() showSecondary = false;
  @Output() saveButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() historyButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() secondaryButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() languageChanged: EventEmitter<number> = new EventEmitter();
  languages: DropDownOption[] = [];
  selectedLanguage = 0;
  customBack = false;
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    // this.connectionService.allEntityData(
    //   `${AppConfigService.settings.baseUrl}data-api/Language`,
    //   (d) => {
    //     this.languages = d.value;
    //   }
    // );
    setTimeout(() => {
      this.languages = this.commonService.dropDownMetaData['languages'];
     
      const defualLanguage = this.languages.find(
        (x) => x.Additional?.isDefault === true
      );
      if (defualLanguage != null) {
        this.selectedLanguage = +defualLanguage.Code;
        this.changeLanguage();
      }
    }, 500);

    const isCustomBack = this.route.snapshot.queryParams['customBack'];
    if (isCustomBack != null && isCustomBack == 'true') {
      this.customBack = true;
    }
    this.subscriptions.push(
      this.commonService.defaultLanguage.subscribe((lang) => {
        if (lang != null) {
          this.selectedLanguage = +lang.Code;
          this.changeLanguage();
        }
      })
    );

  }

  changeLanguage() {
    this.languageChanged.emit(this.selectedLanguage);
  }

  goToList() {
    if (this.customBack == true) {
      window.history.back();
    } else {
      this.router.navigate([this.componentModel.indexPath]);
    }
  }

}
